/*eslint-disable*/
import React, { useState, useEffect } from 'react'
import AddTitleBar from '../../titleBar/add_titleBar'
import { Container, Segment, Form as FormUi, Grid, Header, Card, Image, Divider, Button } from 'semantic-ui-react'
import { Field as Fieldmik, Formik } from 'formik'
import * as yup from 'yup';
import { MyInput, MyTextArea } from '../../apiInputComponent/myInput'
// import MyJobcardType from '../../apiInputComponent/myjobcardType'
import UploadFile from '../../apiInputComponent/fileUpload'
import ReadAxios from '../../axiosComponent/read'
import UpdateAxios from '../../axiosComponent/update'
import MyCategory from '../../apiInputComponent/myCategory'
import MyMeasurement from '../../apiInputComponent/myMeasurement'
import Axios from 'axios'
import APP_CONSTANTS from '../../../config/constants';
import cogoToast from 'cogo-toast';
import { MORE_THAN_3_CHRACTERS } from '../../../utils/constants';
import { PRODUCT_CATEGORY_REQUIRED, PRODUCT_CODE_REQUIRED, PRODUCT_NAME_REQUIRED } from '../../../utils/validationConstant';
import {productFields} from '../../../utils/constants/product.constants'
import { AllRegex } from '../../../utils/validation';
import { ERROR_MESSAGES } from '../../../utils/constants';


const FormikProductEdit = () => {
    const [oneProduct, setoneProduct] = useState([])
    console.log(oneProduct,'oneProduct')
    const [isLoaded, setisLoaded] = useState(false)
    useEffect(() => {
        let token = localStorage.getItem('apiToken')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')
        let psId = localStorage.getItem('Pid')

        Axios.get(`${APP_CONSTANTS.BASE_URL}masters/psLineItem?psId=${psId}&customerNumber=${customerNo}&userId=${userId}&customer_no=${customerNo}&customerNo=${customerNo}&psType=1`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": token,
                "Access-Control-Allow-Origin": "*" 
            }
        }).then((response => {
            // console.log(response.data.data)
            setoneProduct(response.data.resultSet)
            setisLoaded(true)
        }))
        .catch(error => console.log(error))

        // ReadAxios({ url: 'pslineitem/getPS', readItems: { type: [1], psId: localStorage.getItem('Pid') } })
        //     .then((result) => {
        //         setoneProduct(result[0])
        //         setisLoaded(true)
        //     })
    }, [])
    // console.log('-----', oneProduct)
    if (oneProduct.length === 0) {
        return (
            <Header>Loading...</Header>
        )
    } else {
        return (
            <>
                <AddTitleBar Title="Product " LinkName="/product" />
                {isLoaded ? <>
                    <Segment className="m-2">
                        <Container fluid>
                            <Formik
                                initialValues={{
                                    psId: localStorage.getItem('Pid'),
                                    psCode: oneProduct[0].psCode,
                                    psDescription: oneProduct[0].psDescription,
                                    categoryId: oneProduct[0].categoryId,
                                    uom: oneProduct[0].uomId,
                                    unitNetWeight: oneProduct[0].unitNetWeight,
                                    length: oneProduct[0].length,
                                    height: oneProduct[0].height,
                                    width: oneProduct[0].width,
                                    gstPercentage: oneProduct[0].gstPercentage,
                                    imageFile: '',
                                    tdsTaxSectionId: oneProduct[0].tdsTaxSectionId,
                                    purchasePrice: oneProduct[0].purchasePrice,
                                    purchaseDesc: oneProduct[0].purchaseDesc,
                                    openingStock: oneProduct[0].openingStock,
                                    sellingPrice: oneProduct[0].sellingPrice,
                                    sellingDesc: oneProduct[0].sellingDesc,
                                    reorderLevel: oneProduct[0].reorderLevel,
                                    psLineItemGLCode: oneProduct[0].psLineItemGLCode,
                                    psType: "1",
                                }}
                                validationSchema = {
                                    yup.object({
                                        psDescription: yup.string().min(3, MORE_THAN_3_CHRACTERS).required(PRODUCT_NAME_REQUIRED),
                                        psCode: yup.string().min(3, MORE_THAN_3_CHRACTERS),
                                        categoryId: yup.string().required(PRODUCT_CATEGORY_REQUIRED),
                                        psLineItemGLCode: yup.string().optional().nullable().matches(AllRegex.WITHOUT_SPECIAL_CHARECTERS_AND_SPACE, ERROR_MESSAGES.INVALID_FIELD("GL Code"))
                                    })
                                }
                                onSubmit={(values, { setSubmitting }) => {
                                    // let imageFile = values.imageFile.base64 ? values.imageFile.base64 : oneProduct.image ? '' : ''
                                    
                                    setSubmitting(true)
                                    // console.log(combine)
                                    let psId = localStorage.getItem('Pid')
                                    let token = localStorage.getItem('apiToken')
                                    let userId = localStorage.getItem('userId')
                                    let customerNo = localStorage.getItem('customerNo')

                                    let combine = { 
                                        ...values, 
                                        customerNumber: customerNo,
                                        timestamp: new Date(),
                                        userId: userId
                                     }
                                    Axios.patch(`${APP_CONSTANTS.BASE_URL}masters/psLineItem/${psId}?userId=${userId}&customerNumber=${customerNo}`, combine, {
                                        headers: {
                                            'Content-Type': 'application/json',
                                            "Authorization": token,
                                            "Access-Control-Allow-Origin": "*" 
                                        }
                                    }).then((response => {
                                        if(response.data.status == 200){
                                        cogoToast.success(response.data.message)
                                        setTimeout(() => {                                           
                                            window.location.href = '/product'
                                        }, 500);
                                        setSubmitting(false)
                                        
                                    }
                                    else if(response.data.status == 204){
                                        cogoToast.error(response.data.message)
                                        setSubmitting(false)
                                }
                                        
                                    }))
                                    .catch(error => {
                                        console.log(error);
                                        cogoToast.error(response.data.message)
                                        setSubmitting(false);
                                    })

                                }}
                            >
                                {({ touched, errors, values, isSubmitting, handleSubmit }) => {
                                    return (
                                        <div className="ui form">
                                            <Grid>
                                                <Grid.Row>
                                                    <Grid.Column width="8">
                                                        {/* {console.log("One Product Data" , oneProduct)} */}
                                                        <Header size="small" className="p-bold-500" color="grey">{productFields.title||"Product Information"}</Header>
                                                        <FormUi.Group inline>
                                                            <FormUi.Field width="6">
                                                                <label className="labelName">{productFields.product_name.title||"Product Name"} * </label>
                                                            </FormUi.Field>
                                                            <Fieldmik width="10" component={MyInput} name="psDescription" placeholder={productFields.product_name.placeholder||"Name"} className={values.psDescription ? '' : 'error'} />
                                                            {touched.psDescription && errors.psDescription ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.psDescription}</strong> : ''}
                                                        </FormUi.Group>
                                                        <FormUi.Group inline>
                                                            <FormUi.Field width="6">
                                                                <label className="labelName">{productFields.product_code.title||"Product Code"}</label>
                                                            </FormUi.Field>
                                                            <Fieldmik width="10" component={MyInput} readOnly={true} name="psCode" placeholder={productFields.product_code.placeholder||"Code"} className={values.psCode ? '' : 'error'} />
                                                            {touched.psCode && errors.psCode ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.psCode}</strong> : ''}

                                                        </FormUi.Group>
                                                        <FormUi.Group inline>
                                                            <FormUi.Field width="6">
                                                                <label className="labelName">{productFields.category.title||"Category"} *</label>
                                                            </FormUi.Field>
                                                            <Fieldmik width="10" style={{ width: 320 }} component={MyCategory} value={values.categoryId} name="categoryId" placeholder={productFields.category.placeholder||"Category"}  className={values.categoryId ? '' : 'error'}  />
                                                            {touched.categoryId && errors.categoryId ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.categoryId}</strong> : ''}
                                                        
                                                        </FormUi.Group>
                                                        <FormUi.Group inline>
                                                            {/* <FormUi.Field width="6">
                                                                <label className="labelName">UOM</label>
                                                            </FormUi.Field>
                                                            <Fieldmik width="10" style={{ width: 320 }} component={MyMeasurement} value={values.uom} name="uom" placeholder="Select Measurement" /> */}
                                                        </FormUi.Group>
                                                        <FormUi.Group inline>
                                                            <FormUi.Field width="6">
                                                                <label className="labelName">{productFields.weight.title||"Weight"}</label>
                                                            </FormUi.Field>
                                                            <Fieldmik width="10" style={{ width: 320 }} value={values.unitNetWeight} name="unitNetWeight" placeholder={productFields.weight.placeholder||"Weight"} />
                                                        </FormUi.Group>
                                                        <FormUi.Group inline>
                                                            <FormUi.Field width="6">
                                                                <label className="labelName">{productFields.dimension.title||"Dimension"}</label>
                                                            </FormUi.Field>
                                                            <Fieldmik width="3" component={MyInput} name="height" placeholder={productFields.dimension.height||"Height"} />
                                                            <Fieldmik width="3" component={MyInput} name="width" placeholder={productFields.dimension.width||"Width"} />
                                                            <Fieldmik width="4" component={MyInput} name="length" placeholder={productFields.dimension.length||"Length"} />
                                                        </FormUi.Group>
                                                        <FormUi.Group inline>
                                                            <FormUi.Field width="6">
                                                                <label className="labelName">{productFields.gst.title||"GST %"}</label>
                                                            </FormUi.Field>
                                                            <Fieldmik width="10" component={MyInput} name="gstPercentage" placeholder={productFields.gst.placeholder||"GST%"} />
                                                        </FormUi.Group>
                                                        <FormUi.Group inline>
                                                            <FormUi.Field width="6">
                                                                <label className="labelName">{productFields.tds.title||"TDS %"}</label>
                                                            </FormUi.Field>
                                                            <Fieldmik width="10" component={MyInput} name="tdsTaxSectionId" placeholder={productFields.tds.placeholder||"TDS%"} />
                                                        </FormUi.Group>
                                                        <FormUi.Group inline>
                                                            <FormUi.Field width="6">
                                                                <label className="labelName">{productFields.gl_code.title||"GL Code"}</label>
                                                            </FormUi.Field>
                                                            <Fieldmik width="10" component={MyInput} name="psLineItemGLCode" placeholder={productFields.gl_code.placeholder||"GL Code"} />
                                                            {touched.psLineItemGLCode && errors.psLineItemGLCode ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.psLineItemGLCode}</strong> : ''}
                                                        </FormUi.Group>
                                                    </Grid.Column>
                                                    <Grid.Column >
                                                        <Header size="small" className="p-bold-500" color="grey"> &nbsp; </Header>
                                                        <FormUi.Group>
                                                            <FormUi.Field>
                                                                <Card>
                                                                    <Image src={oneProduct.image ? oneProduct.image : 'assets/img/defalutproduct.png'} wrapped ui={false} />
                                                                    <Card.Content extra>
                                                                        <Fieldmik component={UploadFile} typer={[".jpg", ".jpeg"]} buttonName={values.imageFile ? "Image Selected" : "Upload Image"} name="imageFile" />
                                                                        {values.imageFile ? 'Replace Image' : 'Please Select Image'}
                                                                    </Card.Content>
                                                                </Card>
                                                            </FormUi.Field>
                                                        </FormUi.Group>
                                                    </Grid.Column>
                                                </Grid.Row>
                                                <Divider fitted />
                                                <Grid.Row>
                                                    <Grid.Column width="8">
                                                        <Header size="small" className="p-bold-500" color="grey">{productFields.purchase_information||"Purchase Information"}</Header>
                                                        <FormUi.Group inline>
                                                            <FormUi.Field width="6">
                                                                <label className="labelName">{productFields.purchase_amount.title||"Purchase Price(INR)"}</label>
                                                            </FormUi.Field>
                                                            <Fieldmik width="10" component={MyInput} name="purchasePrice" placeholder={productFields.purchase_amount.placeholder||"Rs."} />
                                                        </FormUi.Group>
                                                        <FormUi.Group inline>
                                                            <FormUi.Field width="6">
                                                                <label className="labelName">{productFields.description.title||"Description"}</label>
                                                            </FormUi.Field>
                                                            <Fieldmik width="10" component={MyTextArea} name="purchaseDesc" />
                                                        </FormUi.Group>
                                                        <FormUi.Group inline>
                                                            <FormUi.Field width="6">
                                                                <label className="labelName">{productFields.opening_stock.title||"Opening Stock"}</label>
                                                            </FormUi.Field>
                                                            <Fieldmik width="10" component={MyInput} name="openingStock" />
                                                        </FormUi.Group>
                                                    </Grid.Column>
                                                    <Grid.Column width="8">
                                                        <Header size="small" className="p-bold-500" color="grey">{productFields.sales_information||"Sales Information"}</Header>
                                                        <FormUi.Group inline>
                                                            <FormUi.Field width="6">
                                                                <label className="labelName">{productFields.sellling_price.title||"Selling Price(INR)"}</label>
                                                            </FormUi.Field>
                                                            <Fieldmik width="10" component={MyInput} name="sellingPrice" placeholder={productFields.sellling_price.placeholder||"Rs"} />
                                                        </FormUi.Group>
                                                        <FormUi.Group inline>
                                                            <FormUi.Field width="6">
                                                                <label className="labelName">{productFields.description.title||"Description"}</label>
                                                            </FormUi.Field>
                                                            <Fieldmik width="10" component={MyTextArea} name="sellingDesc" />
                                                        </FormUi.Group>
                                                        <FormUi.Group inline>
                                                            <FormUi.Field width="6">
                                                                <label className="labelName">{productFields.reorder_level.title||"Reorder Level"}</label>
                                                            </FormUi.Field>
                                                            <Fieldmik width="10" component={MyInput} name="reorderLevel" />
                                                        </FormUi.Group>
                                                    </Grid.Column>
                                                </Grid.Row>
                                            </Grid>
                                            <center className="m-2"><Button disabled={isSubmitting} primary type="submit" onClick={handleSubmit} size="mini">Submit</Button></center>
                                        </div>
                                    )
                                }}

                            </Formik>
                        </Container>
                    </Segment>
                </> : 'Loading'}
            </>
        )
    }


}

export default FormikProductEdit
